import React from "react";
import CounterPart from "../common/CounterPart";
import HardikImg from "../images/hardik.webp";
import JitenImg from "../images/jiten.webp";
import { useTranslation } from "react-i18next";

const CoreTeam = () => {
    const { t } = useTranslation();
    const data = [
        { image: HardikImg, num: "Hardik Nimbark", name: t("founder_ceo"), profileUrl: "https://www.linkedin.com/in/hardiknimbark", roleDescription: t("founder_ceo_desc") },
        { image: JitenImg, num: "Jiten Siddhpura", name: t("cto"), profileUrl: "https://www.linkedin.com/in/jiten-siddhpura-b3205036/", roleDescription: t("cto_desc") },
    ];

    return (
        <div >
            <CounterPart data={data} title={t("team")} subtitle={t("team_sec_desc")} />
        </div>
    );
};

export default CoreTeam;
